//-------------------------------------------------------------------------------------------------- Imports
import { Col, Row } from "antd";
import ListComponent, { ListComponentData } from "../../components/ListComponent";
import Slider from "../../components/Slider";
import SubDefaultLayout from "../../components/SubDefaultLayout";
import { useNavigate } from "react-router-dom";
import CardStatusPayment from "./components/CardStatusPayment";
import { useCallback, useEffect, useState } from "react";
import { getExpirationCard, getPaymentsGeneral, getPaymentsGeneralWithCache, getPopup } from "../../methods/Methods";
import { useDispatch, useSelector } from "react-redux";
import { getGeneralData } from "../../stores/slices/generalDataSlice";
import _ from "lodash";
import { GenericResponse, ResponsePaymentGeneral, ResponsePopUp, Tarjeta } from "../../types/common";
import { getPaymentDataContracts, setPaymentDataToContract } from "../../stores/slices/paymentDataSlice";
import { AppDispatch } from "../../stores/store";
import { clearAlertImage, setAlertImage, showAlertImage } from "../../stores/slices/alertImageSlice";
import { DispatchAlertImageOpts } from "../../components/DefaultLayout";

interface ModalSuscriptorData {
    idCliente: string,
}

//-------------------------------------------------------------------------------------------------- View
const Payment = () => {
    const emptyCard: Tarjeta = {
        vencimiento: {
            mes: 0,
            anio: 0
        },
        terminacion: ""
    }
    const dispatch = useDispatch<AppDispatch>();
    const generalData = useSelector(getGeneralData);
    const paymentDataRedux = useSelector(getPaymentDataContracts);
    const navigate = useNavigate();
    const optionsArray: Array<ListComponentData> = [
        { title: "Domiciliar Pago ", subtitle: "" },
        { title: "Pago con Tarjeta de Crédito o Débito", subtitle: "" },
        { title: "Paypal", subtitle: "" },
        { title: "Pago en Centros de Cobros Asociados", subtitle: "" },
        { title: "Pago en CIS", subtitle: "" },
        { title: "Últimos Pagos", subtitle: "" },
    ];
    const [paymentData, setPaymentData] = useState<ResponsePaymentGeneral>();
    const [loading, setLoading] = useState<boolean>(false);
    const [recurrentCard, setRecurrentCard] = useState<Tarjeta | null>(emptyCard);
    const [idCliente, setIdCliente] = useState<string>("");
    const [wasSeen, setWasSeen] = useState(false);

    const goToRoute = (element: ListComponentData) => {
        switch (element.title) {
            case "Domiciliar Pago ":
                navigate('/payments/monthly-payment')
                break;
            case "Pago con Tarjeta de Crédito o Débito":
                navigate('/payments/card-payment')
                break;
            case "Paypal":
                navigate('/payments/paypal');
                break;
            case "Pago en Centros de Cobros Asociados":
                navigate('/payments/payment-centers')
                break;
            case "Pago en CIS":
                navigate('/payments/payment-cis')
                break;
            case "Últimos Pagos":
                navigate('/payments/history')
                break;
            default:
                break;
        }
    };

    const onPressBtnPrimary = useCallback((popupData: ResponsePopUp, idCliente: string) => {
        dispatch(showAlertImage(false));
        dispatch(clearAlertImage());

        const hasSeenStorage = localStorage.getItem("hasSeenModalDom");
        let hasSeenStorageArray: Array<ModalSuscriptorData> = []
        if (hasSeenStorage) {
            hasSeenStorageArray = JSON.parse(hasSeenStorage);
        }
        let suscriptorObj: ModalSuscriptorData = {
            idCliente: idCliente,
        }

        hasSeenStorageArray.push(suscriptorObj);
        localStorage.setItem("hasSeenModalDom", JSON.stringify(hasSeenStorageArray));

        if (popupData && _.startsWith(popupData?.accept_btn_link, "http")) {
            window.open(popupData.accept_btn_link, "_blank");
        } else {
            if (_.isEqual(popupData?.accept_btn_link, "MonthlyPayments")) {
                navigate('/payments/monthly-payment');
            } else {
                if (popupData?.accept_btn_link) {
                    navigate(popupData.accept_btn_link);
                }
            }
        }
    }, [dispatch, navigate]);

    const onPressBtnSecondary = useCallback((popupData: ResponsePopUp, idCliente: string) => {
        dispatch(showAlertImage(false));
        dispatch(clearAlertImage());

        const hasSeenStorage = localStorage.getItem("hasSeenModalDom");
        let hasSeenStorageArray: Array<ModalSuscriptorData> = []
        if (hasSeenStorage) {
            hasSeenStorageArray = JSON.parse(hasSeenStorage);
        }
        let suscriptorObj: ModalSuscriptorData = {
            idCliente: idCliente,
        }

        hasSeenStorageArray.push(suscriptorObj);
        localStorage.setItem("hasSeenModalDom", JSON.stringify(hasSeenStorageArray));

        if (popupData && _.startsWith(popupData?.cancel_btn_link, "http")) {
            window.open(popupData.cancel_btn_link, "_blank");
        } else if (popupData?.cancel_btn_link) {
            navigate(popupData?.cancel_btn_link);
        }
    }, [dispatch, navigate]);

    const openAlertModal = useCallback((option: DispatchAlertImageOpts) => {
        dispatch(setAlertImage({
            show: true,
            onPressBtnPrimary: option.onPressBtnPrimary,
            onPressBtnSecondary: option.onPressBtnSecondary,
            popupData: option.popupData
        }));
    }, [dispatch]);

    const getPopUpFnt = useCallback(async (idCliente: string) => {
        await getPopup(idCliente)
            .then((response) => {
                if (response.data && response.data.data) {
                    response.data.data.forEach((element) => {
                        if (element.accept_btn_link === "MonthlyPayments") {
                            let dispatchAlert: DispatchAlertImageOpts = {
                                onPressBtnPrimary: () => onPressBtnPrimary(element, idCliente),
                                onPressBtnSecondary: () => onPressBtnSecondary(element, idCliente),
                                popupData: element
                            }
                            openAlertModal(dispatchAlert);
                        }
                    })
                }
            })
            .catch(() => {
            });
    }, [openAlertModal, onPressBtnPrimary, onPressBtnSecondary])

    const getPaymentDataCache = useCallback(async () => {
        setLoading(true);
        await getPaymentsGeneralWithCache(idCliente)
            .then(async (response) => {
                if (!_.isEmpty(response.data) && !_.isEmpty(response.data.data[0])) {
                    setPaymentData(response.data.data[0]);
                    let recurrentCard: Tarjeta | null = null;
                    await getExpirationCard(idCliente)
                        .then((response) => {
                            if (response.data && response.data.data[0]) {
                                //Si el campo tarjeta no está null es porque tiene tarjeta domiciliada
                                //Y si es diferente del cod 902
                                if (!_.isNull(response.data.data[0].tarjeta) && response.data.data[0].codigo !== "902") {
                                    recurrentCard = response.data.data[0].tarjeta;
                                    setRecurrentCard(response.data.data[0].tarjeta);
                                }
                                else {
                                    if (!wasSeen) {
                                        getPopUpFnt(idCliente);
                                    }
                                }
                            }
                        })
                        .catch(() => {
                        });
                    dispatch(setPaymentDataToContract({
                        clientId: idCliente,
                        paymentData: response.data.data[0],
                        recurrentCard: recurrentCard
                    }));
                }
                else {
                    setPaymentData(undefined);
                }
                setLoading(false);
            })
            .catch(() => {
                setPaymentData(undefined);
                setLoading(false);
            });
    }, [dispatch, idCliente, getPopUpFnt, wasSeen]);

    const getPaymentData = useCallback(async () => {
        setLoading(true);

        await getPaymentsGeneral(idCliente)
            .then(async (response: GenericResponse<ResponsePaymentGeneral>) => {
                if (!_.isEmpty(response.data)) {
                    setPaymentData(response.data[0]);
                    let recurrentCard: Tarjeta | null = null;
                    await getExpirationCard(idCliente)
                        .then((response) => {
                            if (response.data && response.data.data[0]) {
                                //Si el campo tarjeta no está null es porque tiene tarjeta domiciliada
                                //Y si es diferente del cod 902
                                if (!_.isNull(response.data.data[0].tarjeta) && response.data.data[0].codigo !== "902") {
                                    recurrentCard = response.data.data[0].tarjeta;
                                    setRecurrentCard(response.data.data[0].tarjeta);
                                }
                                else {
                                    if (!wasSeen) {
                                        getPopUpFnt(idCliente);
                                    }
                                }
                            }
                        })
                        .catch(() => {
                        });
                    dispatch(setPaymentDataToContract({
                        clientId: idCliente,
                        paymentData: response.data[0],
                        recurrentCard: recurrentCard
                    }));
                }
                else {
                    setPaymentData(undefined);
                }
                setLoading(false);
            }).catch(() => {
                setPaymentData(undefined);
                setLoading(false);
            });
    }, [dispatch, idCliente, getPopUpFnt, wasSeen]);

    useEffect(() => {
        let idCliente = "";
        if (generalData.selectedContract !== null) {
            setIdCliente(
                generalData.selectedContract.sucursal + generalData.selectedContract.suscriptor
            );
            idCliente = generalData.selectedContract.sucursal + generalData.selectedContract.suscriptor;
        }
        const hasSeenModal = localStorage.getItem("hasSeenModalDom");
        setWasSeen(false);
        if (hasSeenModal) {
            const hasSeenStorageArray: Array<ModalSuscriptorData> = JSON.parse(hasSeenModal);
            hasSeenStorageArray.forEach(elem => {
                if (_.isEqual(elem.idCliente, idCliente)) {
                    setWasSeen(true);
                }
            })
        }
    }, [generalData.selectedContract]);

    useEffect(() => {
        if (idCliente) {
            const index = paymentDataRedux.contracts.findIndex(obj => obj.clientId === idCliente);
            if (index >= 0) {
                setRecurrentCard(paymentDataRedux.contracts[index].recurrentCard);
                setPaymentData(paymentDataRedux.contracts[index].paymentData);
            }
            else {
                getPaymentDataCache();
            }
        }
    }, [idCliente, getPaymentDataCache, paymentDataRedux.contracts]);

    useEffect(() => {
        if (paymentDataRedux) {
            setLoading(false);
        }
    }, [paymentDataRedux]);

    return (
        <SubDefaultLayout title={"Formas de Pago"} >
            <Slider />
            <Row gutter={[12, 12]} style={{ marginTop: 30 }}>
                <Col xs={24} xxl={12}>
                    <CardStatusPayment
                        isLoading={loading}
                        currentBalance={paymentData?.payment.datos}
                        hasDebt={paymentData?.hasDebt}
                        limitPaymentDate={paymentData?.payment.datos?.paymentLimitDate}
                        actualizationDateTime={new Date()}
                        onrefreshPress={getPaymentData}
                        hasRecurrentPayments={_.isNull(recurrentCard) ? false : true}
                    />
                </Col>
                <Col xs={24} xxl={12}>
                    <ListComponent
                        arrayList={optionsArray}
                        onPress={(option: ListComponentData) => goToRoute(option)}
                    />
                </Col>
            </Row>
        </SubDefaultLayout >
    );
};

//-------------------------------------------------------------------------------------------------- Exports
export default Payment;
